import { defineStore } from 'pinia'

// crypto.randomUUID 的 fallback
const generateId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Fallback for older browsers
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
}

interface Notification {
  id: string
  type: 'success' | 'error' | 'warning' | 'info'
  title: string
  message?: string
  duration?: number
}

interface UIState {
  sidebarCollapsed: boolean
  loading: boolean
  notifications: Notification[]
}

export const useUIStore = defineStore('ui', {
  state: (): UIState => ({
    sidebarCollapsed: false,
    loading: false,
    notifications: [],
  }),

  actions: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },

    setLoading(value: boolean) {
      this.loading = value
    },

    notify(notification: Omit<Notification, 'id'>) {
      const id = generateId()
      const duration = notification.duration ?? 3000

      this.notifications.push({ ...notification, id })

      if (duration > 0) {
        setTimeout(() => this.removeNotification(id), duration)
      }
    },

    removeNotification(id: string) {
      const index = this.notifications.findIndex(n => n.id === id)
      if (index > -1) {
        this.notifications.splice(index, 1)
      }
    },
  },
})
